import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";

export const CustomerFieldsCard = ({ customFields }: { customFields: any }) => {
  const { language } = useAuth();
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{dictionary["additional-information"][language]}</h2>
      
      <div className="space-y-1 text-gray-700">
        {customFields.map((field: any) => (
          <div key={field.key} className="flex flex-row gap-2 items-center">
            <p className="font-medium">{field.key}:</p>
            <p>{field.value as string}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
